import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	selected: 12,
	title: 'Показване на цени за:',
	options: [
		{
			id: 1,
			label: '1 месец',
			months: 1,
			discount: null
		},
		{
			id: 12,
			label: '12 месеца',
			months: 12,
			discount: null
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	selected: 12,
	title: 'Display prices for:',
	options: [
		{
			id: 1,
			label: '1 month',
			months: 1,
			discount: null
		},
		{
			id: 12,
			label: '12 months',
			months: 12,
			discount: null
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];